<!-- Persoana fizica -->
<div class="g-0" *ngIf="isPersoanaFizica">
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-regular fa-user"></i>
                                <span>Subsemnatul</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onSubsemnatulInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                    <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere?.beneficiar.length !== 0" value="beneficiar">Beneficiar</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'info'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Nume</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.nume }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Prenume</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.prenume }}</td>
                            </tr>
                            <tr>
                                <!-- Check if cnp is not null -->
                                <ng-container *ngIf="cerere?.cetatean?.cnp; else renderCUI">
                                    <td class="text-center">
                                        <strong>CNP</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.cetatean?.cnp }}</td>
                                </ng-container>
                                <!-- Template to render if cnp is null -->
                                <ng-template #renderCUI>
                                    <td class="text-center">
                                        <strong>CUI</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.cetatean?.cui }}</td>
                                </ng-template>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Email</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.email }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Telefon</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.telefon }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'adresa'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.judet }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Oraș/Municipiu/Comuna/Sat</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.oras }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.sector !== null">
                                <td class="text-center">
                                    <strong>Sector</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.sector }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.strada }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.numar }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.bloc !== null">
                                <td class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.bloc }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.scara !== null">
                                <td class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.scara }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.etaj !== null">
                                <td class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.etaj }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.apartament !== null">
                                <td class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.apartament }}</td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.cod_postal !== null">
                                <td class="text-center">
                                    <strong>Cod Poștal</strong>
                                </td>
                                <td class="text-left">{{ cerere?.homeAddress?.cod_postal }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'beneficiar'">
                        <tbody>
                            <tr *ngFor="let beneficiar of cerere?.beneficiar; let i = index">
                                <td colspan="2">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <button type="button" class="btn btn-xs" [ngClass]="{'btn-primary': this.selectedBeneficiarIndex === i, 'btn-light': this.selectedBeneficiarIndex !== i}" (click)="this.selectedBeneficiarIndex = i; this.selectedBeneficiaryInfoStatus='info'">
                                                Beneficiar #{{ i + 1 }}
                                            </button>
                                        </div>  
                                    </div>
                                    <div *ngIf="this.selectedBeneficiarIndex === i">
                                        <div class="col d-flex justify-content-start p-2">
                                            <div>
                                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onBeneficiarInfoChange($event)" value="info">
                                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                                    <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                                                </mat-button-toggle-group>
                                            </div>
                                        </div>
                                        <table class="table table-condensed table-wrapper-box" *ngIf="selectedBeneficiaryInfoStatus === 'info'">
                                            <tbody>
                                                <!-- beneficiar PF -->
                                                <ng-container *ngIf="beneficiar.persoana_type === 1">
                                                    <tr *ngIf="beneficiar.nume !== null">
                                                        <td width="40%" class="text-center">
                                                            <strong>Nume</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.nume }}</td>
                                                    </tr>
                                                    <tr *ngIf="beneficiar.prenume !== null">
                                                        <td class="text-center">
                                                            <strong>Prenume</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.prenume }}</td>
                                                    </tr>
                                                    <tr *ngIf="beneficiar.cnp !== null">
                                                        <td class="text-center">
                                                            <strong>CNP</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.cnp }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">
                                                            <strong>Serie/Număr CI</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.ci_serie || 'N/A' }} - {{ beneficiar.ci_numar || 'N/A' }}</td>
                                                    </tr>
                                                    <tr *ngIf="beneficiar.ci_emitent !== null">
                                                        <td class="text-center">
                                                            <strong>CI Emitent</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.ci_emitent }}</td>
                                                    </tr>
                                                </ng-container>
                                                <!-- beneficiar PJ -->
                                                <ng-container *ngIf="beneficiar.persoana_type === 2">
                                                    <tr *ngIf="beneficiar.denumire !== null">
                                                        <td width="40%" class="text-center">
                                                            <strong>Denumire companie</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.denumire }}</td>
                                                    </tr>
                                                    <tr *ngIf="beneficiar.cui !== null">
                                                        <td class="text-center">
                                                            <strong>CUI/CIF</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.cui }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center">
                                                            <strong>Registrul comerțului</strong>
                                                        </td>
                                                        <td class="text-left">{{ beneficiar.reg_com || 'N/A' }}</td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                        <table class="table table-condensed table-wrapper-box" *ngIf="selectedBeneficiaryInfoStatus === 'adresa'">
                                            <tbody>
                                                <tr *ngIf="beneficiar.addresses.judet_name !== null">
                                                    <td width="40%" class="text-center">
                                                        <strong>Județ</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.judet_name }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.oras !== null">
                                                    <td class="text-center">
                                                        <strong>Oraș</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.oras }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.strada !== null">
                                                    <td class="text-center">
                                                        <strong>Strada</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.strada }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.numar !== null">
                                                    <td class="text-center">
                                                        <strong>Număr</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.numar }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.bloc !== null">
                                                    <td class="text-center">
                                                        <strong>Bloc</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.bloc }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.scara !== null">
                                                    <td class="text-center">
                                                        <strong>Scara</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.scara }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.etaj !== null">
                                                    <td class="text-center">
                                                        <strong>Etaj</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.etaj }}</td>
                                                </tr>
                                                <tr *ngIf="beneficiar.addresses.apartament !== null">
                                                    <td class="text-center">
                                                        <strong>Apartament</strong>
                                                    </td>
                                                    <td class="text-left">{{ beneficiar.addresses.apartament }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="box-wrapper box-property">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-location-crosshairs"></i>
                                <span>Adresă imobil</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.strada }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.numar }}</td>
                            </tr>
                            <tr *ngIf="cerere?.propertyAddress?.bloc !== null">
                                <td class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.bloc }}</td>
                            </tr>
                            <tr *ngIf="cerere?.propertyAddress?.scara !== null">
                                <td class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.scara }}</td>
                            </tr>
                            <tr *ngIf="cerere?.propertyAddress?.etaj !== null">
                                <td class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.etaj }}</td>
                            </tr>
                            <tr *ngIf="cerere?.propertyAddress?.apartament !== null">
                                <td class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.apartament }}</td>
                            </tr>
                            <tr *ngIf="cerere?.propertyAddress?.cod_postal !== null">
                                <td class="text-center">
                                    <strong>Cod Poștal</strong>
                                </td>
                                <td class="text-left">{{ cerere?.propertyAddress?.cod_postal }}</td>
                            </tr>
                            <tr *ngIf="cerere?.informatii?.numar_cadastral && cerere?.informatii?.numar_cadastral !== null">
                                <td class="text-center">
                                    <strong>Număr cadastral</strong>
                                </td>
                                <td class="text-left">{{ cerere?.informatii?.numar_cadastral ? cerere?.informatii?.numar_cadastral : 'N/A' }}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="selectedBeneficiaryInfoStatus === 'adresa'">

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Persoana juridica -->
<!-- <div class="g-0">

    <div class="box-wrapper box-property">
        <div class="box-content-header">
            <div class="row p-1">
                <div class="col">
                    <mat-card-title>
                        <i class="fa-solid fa-clipboard-list"></i>
                        <span>Informații adiționale</span>
                    </mat-card-title>
                </div>
            </div>
        </div>
        <div class="box-content-body">

        </div>
    </div>

    <div class="row p-3">
        <div class="col">

        </div>
        <div class="col d-flex justify-content-end">
                <div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onPJInfoFilesChange($event)"
                        value="info">
                        <mat-button-toggle value="info">Info</mat-button-toggle>
                        <mat-button-toggle value="orar">Orar</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="row p-3" *ngIf="selectedPJFiles === 'info'">
                <div class="col">
                    <div>Activități CAEN</div>
                    <div class="fw-bold">{{ mockUserPJ.suplimentare.caen }}</div>
                </div>
                <div class="col">
                    <div>Observații</div>
                    <div class="fw-bold">{{ mockUserPJ.suplimentare.observatii }}</div>
                </div>
            </div>
            <div class="row p-3" *ngIf="selectedPJFiles === 'orar'">
                <div class="col">
                    <div>Test</div>
                    <div class="fw-bold">{{ mockUserPJ.orar.orar1 }}</div>
                </div>
                <div class="col">
                    <div>Observații</div>
                    <div class="fw-bold">{{ mockUserPJ.orar.orar2 }}</div>
                </div>
            </div>
    </div>

</div> -->